interface ICluster {
  id: string;
  name: string;
  code: string;
  hub_id: string;
}

interface IStore {
  id: string;
  name: string;
  address: string;
  cluster: ICluster | null;
  is_mobile_verified: boolean;
  store_category: {
    name: string;
    payment_options: string[];
  };
}

export interface IFMCGStore {
  id: string | null;
  account_id: string | null;
  name: string | null;
  photo: string | null;
  address: string | null;
  contact_no: string | null;
  customer_name: string | null;
  city: string | null;
  cluster_id: string | null;
  loyalty_status: string | null;
  is_order_blocked: string | null;
  is_points_purchase_blocked: string | null;
  is_telco_blocked: string | null;
  point_x: string | null;
  point_y: string | null;
  province: string | null;
  locality: string | null;
  is_mobile_verified: string | null;
  is_self_store: string | null;
  online_shop_link: string | null;
  retailer_type: string | null;
  store_category_id: string | null;
  is_key_account: number | null;
  store_categories: string[];
  is_paylater_blocked: string | null;
  loan_due: string | null;
  loan_due_date: string | null;
  loan_phase: string | null;
  referral_code: string | null;
  referral_msg: string | null;
  security_questions_answered: boolean;
}

interface IAccount {
  id: string | null;
  username: string | null;
  displayName: string | null;
  email: string | null;
  state: string | null;
  type: string | null;
  role: string | null;
  isLocked: string | null;
  croCollectionLimit: string | null;
  profilePic: string | null;
  employeeId: string | null;
  store: IFMCGStore;
}

export interface IFMCGProfile {
  id: string;
  account: IAccount;
}

export interface IAccountProfile {
  id: string;
  name: string;
  store: IStore;
  fmcg_profile: IFMCGProfile;
  fmcg_store_id: string;
  points: number | null;
  maxElistaLimit: string | null;
  eListaTotalBalance: string | null;
  eListaAvailableBalance: string | null;
}

export enum StoreCategoryPaymentOptions {
  GROWCOINS = "GROWCOINS",
  COD = "COD",
  "E-LISTA" = "E-LISTA",
}

export interface IUpdateProfile {
  id?: string;
  name?: string;
  store?: IStore;
  fmcg_profile?: IFMCGProfile;
  fmcg_store_id?: string;
  points?: number | null;
  maxElistaLimit?: string | null;
  eListaTotalBalance?: string | null;
  eListaAvailableBalance?: string | null;
}

export enum IAccountTypes {
  STORE = "STORE",
  SALESPERSON = "SALESPERSON",
}

export enum IAccountRoles {
  USER = "USER",
}

export enum IStoreCategoryNames {
  NORMAL = "normal",
  INSTITUTIONAL_ACCOUNT = "institutional accounts",
  KEY_ACCOUNT = "KEY_ACCOUNT",
}
